export const isStorageAvailable = () => {
  try {
    const testKey = '__test__';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

class StorageManager {
  constructor() {
    this.isAvailable = isStorageAvailable();
  }

  dispatchStorageEvent = (key, newValue) => {
    dispatchEvent(new StorageEvent('storage', { key, newValue }));
  };

  setItem = (key, value) => {
    if (!this.isAvailable) return;

    const stringifiedValue = JSON.stringify(value);
    localStorage.setItem(key, stringifiedValue);
    this.dispatchStorageEvent(key, stringifiedValue);
  };

  removeItem = (key) => {
    if (!this.isAvailable) return;

    localStorage.removeItem(key);
    this.dispatchStorageEvent(key, null);
  };

  getItem = (key) => {
    if (!this.isAvailable) return null;

    return localStorage.getItem(key);
  };
}

export default StorageManager;
